var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Utils from "../utils/utils";
var Attribute = /** @class */ (function () {
    function Attribute(input) {
        var _this = this;
        this.id = null;
        this.logoColor = "";
        this.name = "";
        this.order = null;
        this.role = "";
        // Todo create roles model/enum
        this.roles = [];
        Object.keys(input).map(function (key) {
            var property = Utils.convertToCamelcase(key);
            _this[property] = input[key];
        });
    }
    Attribute.prototype.getRoles = function () {
        return this.roles.join(", ");
    };
    Attribute.fromDataArray = function (dataArray) {
        var attributions = [];
        dataArray.forEach(function (element) {
            var existingEntity = attributions.find(function (x) { return x.id === element.entity_id; });
            if (!existingEntity) {
                attributions.push(new Attribute(__assign({}, element, { id: element.entity_id, role: undefined, roles: [element.role] })));
            }
            else {
                existingEntity.roles.push(element.role);
            }
        });
        return attributions;
    };
    Attribute.prototype.getLogo = function () {
        return this.logoColor;
    };
    return Attribute;
}());
export { Attribute };
